module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "registration"
    }
  }, [_c('div', {
    staticClass: "left-col"
  }, [_c('label', {
    staticClass: "label-default",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Imię "), _c('span', {
    staticClass: "required-star"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "errors"
  }, [_vm._v(_vm._s(_vm.errors.name))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.patient.name),
      expression: "patient.name"
    }],
    staticClass: "input-default",
    class: {
      'input-error': _vm.errors.name
    },
    attrs: {
      "id": "name",
      "type": "text",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.patient.name)
    },
    on: {
      "keyup": function($event) {
        _vm.debounce(_vm.validateRequiredField, 'name')
      },
      "blur": function($event) {
        _vm.validateRequiredField('name')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.patient, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label-default",
    attrs: {
      "for": "surname"
    }
  }, [_vm._v("Nazwisko "), _c('span', {
    staticClass: "required-star"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "errors"
  }, [_vm._v(_vm._s(_vm.errors.surname))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.patient.surname),
      expression: "patient.surname"
    }],
    staticClass: "input-default",
    class: {
      'input-error': _vm.errors.surname
    },
    attrs: {
      "id": "surname",
      "type": "text",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.patient.surname)
    },
    on: {
      "keyup": function($event) {
        _vm.debounce(_vm.validateRequiredField, 'surname')
      },
      "blur": function($event) {
        _vm.validateRequiredField('surname')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.patient, "surname", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label-default",
    attrs: {
      "for": "telephone"
    }
  }, [_vm._v("Telefon "), _c('span', {
    staticClass: "required-star"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "errors"
  }, [_vm._v(_vm._s(_vm.errors.telephone))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.patient.telephone),
      expression: "patient.telephone"
    }],
    staticClass: "input-default",
    class: {
      'input-error': _vm.errors.telephone
    },
    attrs: {
      "id": "telephone",
      "type": "text",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.patient.telephone)
    },
    on: {
      "keyup": function($event) {
        _vm.debounce(_vm.validateTelephoneField)
      },
      "blur": _vm.validateTelephoneField,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.patient, "telephone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label-default",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("E-mail "), _c('span', {
    staticClass: "required-star"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "errors"
  }, [_vm._v(_vm._s(_vm.errors.email))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.patient.email),
      expression: "patient.email"
    }],
    staticClass: "input-default",
    class: {
      'input-error': _vm.errors.email
    },
    attrs: {
      "id": "email",
      "type": "email"
    },
    domProps: {
      "value": (_vm.patient.email)
    },
    on: {
      "keyup": function($event) {
        _vm.debounce(_vm.validateEmailField)
      },
      "blur": _vm.validateEmailField,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.patient, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.emailWarning.show) ? _c('div', {
    staticClass: "duplicated-email-info"
  }, [_c('span', [_vm._v(_vm._s(_vm.emailWarning.shortInfo))]), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.handleEmailWarningAction
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.emailWarning.detailInfo))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "right-col"
  }, [_c('label', {
    staticClass: "label-default"
  }, [_vm._v(" "), _c('span', {
    staticClass: "errors"
  }, [_vm._v(_vm._s(_vm.errors.password))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.patient.password),
      expression: "patient.password"
    }],
    staticClass: "input-default input-password",
    class: {
      'input-error': _vm.errors.password
    },
    attrs: {
      "placeholder": "Wpisz hasło...",
      "type": "password",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.patient.password)
    },
    on: {
      "keyup": function($event) {
        _vm.debounce(_vm.validatePasswordField)
      },
      "blur": _vm.validatePasswordField,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.patient, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label-default"
  }, [_vm._v(" "), _c('span', {
    staticClass: "errors"
  }, [_vm._v(_vm._s(_vm.errors.passwordConfirm))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.patient.passwordConfirm),
      expression: "patient.passwordConfirm"
    }],
    staticClass: "input-default input-password",
    class: {
      'input-error': _vm.errors.passwordConfirm
    },
    attrs: {
      "placeholder": "Potwierdź hasło...",
      "type": "password",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.patient.passwordConfirm)
    },
    on: {
      "keyup": function($event) {
        _vm.debounce(_vm.validatePasswordConfirmField)
      },
      "blur": _vm.validatePasswordConfirmField,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.patient, "passwordConfirm", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "rules-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement),
      expression: "agreement"
    }],
    staticClass: "checkbox-blue",
    attrs: {
      "id": "rules-agreement",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.agreement) ? _vm._i(_vm.agreement, null) > -1 : (_vm.agreement)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.agreement,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.agreement = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.agreement = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.agreement = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rules-agreement"
    }
  }, [_vm._v("\n                Akceptuję "), _c('a', {
    staticClass: "rules-download",
    attrs: {
      "href": _vm.RULES_PDF_URL,
      "download": ""
    }
  }, [_vm._v("regulamin")]), _vm._v(" "), _c('span', {
    staticClass: "required-star"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('button', {
    staticClass: "btn-solid-orange btn-register",
    on: {
      "click": _vm.register
    }
  }, [_vm._v("ZAREJESTRUJ SIĘ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_c('u', [_vm._v("Kliknij tutaj,")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-825afd6a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Registration.vue
// module id = 209
// module chunks = 0